module.exports = __webpack_public_path__ + "img/choice2.d895b065.png";